export const PGI_NAV_ITEMS = [
  { id: "executive", label: "Executive Overview" },
  { id: "ranking", label: "District Ranking" },
  { id: "domains", label: "Domain Performance" },
  { id: "yoy", label: "YoY Improvement" },
  { id: "benchmark", label: "Benchmarking" },
  { id: "risk", label: "Risk & Action" },
  { id: "deepdive", label: "District Deep Dive" },
  { id: "officials", label: "Officials Review" },
];

export const PGI_TAB_ITEMS = [
  { id: "executive", label: "Executive" },
  { id: "ranking", label: "Ranking" },
  { id: "domains", label: "Domains" },
  { id: "yoy", label: "YoY" },
  { id: "benchmark", label: "Benchmarking" },
  { id: "risk", label: "Risk & Action" },
  { id: "deepdive", label: "Deep Dive" },
  { id: "officials", label: "Officials" },
];
